export default __webpack_public_path__ + "static/media/i_angelos.1277a5e1.svg";